// This is the javascript entrypoint for the announcement-bar snippet.
// This file and all its inclusions will be processed through postcss

import '@archetype-themes/scripts/config';
import { Slideshow } from '@archetype-themes/scripts/modules/slideshow';

theme.announcementBar = (function() {
  var args = {
    autoPlay: 5000,
    avoidReflow: true,
    cellAlign: theme.config.rtl ? 'right' : 'left',
    fade: true
  };
  var bar;
  var flickity;

  function init() {
    bar = document.getElementById('AnnouncementSlider');
    if (!bar) {
      return;
    }

    unload();

    if (bar.dataset.blockCount === 1) {
      return;
    }

    flickity = new Slideshow(bar, args);
  }

  // Go to slide if selected in the editor
  function onBlockSelect(id) {
    var slide = bar.querySelector('#AnnouncementSlide-' + id);
    var index = parseInt(slide.dataset.index);

    if (flickity && typeof flickity.pause === 'function') {
      flickity.goToSlide(index);
      flickity.pause();
    }
  }

  function onBlockDeselect() {
    if (flickity && typeof flickity.play === 'function') {
      flickity.play();
    }
  }

  function unload() {
    if (flickity && typeof flickity.destroy === 'function') {
      flickity.destroy();
    }
  }

  return {
    init: init,
    onBlockSelect: onBlockSelect,
    onBlockDeselect: onBlockDeselect,
    unload: unload
  };
})();

/* ---------------------------------------------------------------------------
 * 2026-08-03 ACCESSIBILITY FIX — axe rule `aria-hidden-focus`.
 * The slideshow marks off-screen announcement slides aria-hidden="true" but
 * leaves their links in the tab order, so keyboard users tab into content a
 * screen reader has been told does not exist. Lighthouse flags this as a
 * serious violation on every page.
 *
 * This keeps tabindex in sync with aria-hidden: focusables inside a hidden
 * slide get tabindex="-1", and get it removed again when the slide is shown.
 * Only touches elements it hid itself (data-a11y-untab), so authored
 * tabindex values are preserved.
 * ------------------------------------------------------------------------- */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';

  function sync(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('[aria-hidden="true"]').forEach(function (hidden) {
      hidden.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (el.getAttribute('tabindex') !== '-1') {
          el.setAttribute('data-a11y-untab', '1');
          el.setAttribute('tabindex', '-1');
        }
      });
    });

    root.querySelectorAll('[data-a11y-untab]').forEach(function (el) {
      if (!el.closest('[aria-hidden="true"]')) {
        el.removeAttribute('tabindex');
        el.removeAttribute('data-a11y-untab');
      }
    });
  }

  function start() {
    sync(document);
    var observer = new MutationObserver(function () { sync(document); });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
